import React from "react";
import { Box, Text } from "@chakra-ui/react";

import { launchTokens } from "@/features/launch/constants";

export const LaunchFooter: React.FC = () => {
  return (
    <Box
      as="footer"
      bg={launchTokens.colors.sectionBackground}
      py="24px"
      px="16px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <Text
        fontFamily={launchTokens.fonts.primary}
        fontWeight="600"
        fontSize="12px"
        lineHeight="16px"
        textAlign="center"
        color={launchTokens.colors.textOnDark}
      >
        © 2025-2026 smartBeemo, LLC. Todos los derechos reservados.
      </Text>
    </Box>
  );
};
